import { render, staticRenderFns } from "./ConfigurationContainer.vue?vue&type=template&id=087c7757&scoped=true"
import script from "./ConfigurationContainer.vue?vue&type=script&lang=js"
export * from "./ConfigurationContainer.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationContainer.vue?vue&type=style&index=0&id=087c7757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c7757",
  null
  
)

export default component.exports